var isAndroid = require('is-android');
var isIos = require('is-ios');
module.exports = isAndroid || isIos;